import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBattery = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 4,
	height: 8,
	viewBox: "0 0 4 8",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		opacity: .75,
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.75 0.75C1.47386 0.75 1.25 0.973858 1.25 1.25H0V7.25H4V1.25H2.75C2.75 0.973858 2.52614 0.75 2.25 0.75H1.75Z",
		fill: "currentColor"
	})
});
export default SvgBattery;
